import { render, staticRenderFns } from "./AdminCode.vue?vue&type=template&id=1a88a4be&scoped=true&"
import script from "./AdminCode.vue?vue&type=script&lang=js&"
export * from "./AdminCode.vue?vue&type=script&lang=js&"
import style0 from "./AdminCode.vue?vue&type=style&index=0&id=1a88a4be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a88a4be",
  null
  
)

export default component.exports